// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid___3eHpJ","item":"item___2Sqax","label":"label___axh1-","value":"value___3ROFr","empty":"empty___2UAte","horizontal":"horizontal___3__5-","bordered":"bordered___hy3ue"};